module.exports = __webpack_public_path__ + "static/media/Strength.1e642ab4.jpg";